import { createSteeringURL } from '@/api'
import { components } from '@/steering-types'
import { steeringAuthInit } from '@/stores/auth'
import { Profile, ProfileCreateData } from '@/types'
import { useStoreHelpers } from '@/util'
import {
  APICreate,
  APIListPaginated,
  APIRemove,
  APIRetrieve,
  APIUpdate,
  createExtendableAPI,
} from '@rokoli/bnb/drf'
import { defineStore } from 'pinia'

type ProfileUpdateData = ProfileCreateData
type ProfilePartialUpdateData = components['schemas']['PatchedProfile']

export const useProfileStore = defineStore('profiles', () => {
  const endpoint = createSteeringURL.prefix('profiles')
  const { api, base } = createExtendableAPI<Profile>(endpoint, steeringAuthInit)
  const listOperations = APIListPaginated(api)
  const retrieveOperations = APIRetrieve(api)

  return {
    ...base,
    ...listOperations,
    ...retrieveOperations,
    ...APICreate<Profile, ProfileCreateData>(api),
    ...APIUpdate<Profile, ProfileUpdateData, ProfilePartialUpdateData>(api),
    ...APIRemove(api),
    ...useStoreHelpers({ ...base, ...listOperations, ...retrieveOperations }),
  }
})
